import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchOptions = (listOfOptions) => {
  return api.post(ENDPOINTS.option_values.url, listOfOptions);
};
